<template>
  <v-container fluid>
    <v-navigation-drawer
      fixed
      clipped
      :permanent="this.$vuetify.breakpoint.lgAndUp"
      v-model="drawer"
      app
    >
      <v-list>
        <v-list-tile
          v-for="(item, i) in items()"
          :key="i"
          exact
          :href="item.href"
          :to="item.route"
        >
          <v-list-tile-action>
            <v-icon light v-html="item.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-badge v-show="item.badge && item.badge > 0" right>
              <span slot="badge">{{item.badge}}</span>
              <v-list-tile-title v-text="item.title"></v-list-tile-title>
            </v-badge>
            <v-list-tile-title v-show="!item.badge || item.badge === 0" v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
<!--       <v-footer fixed
      height="auto"
      >
 -->
      <v-card color="grey lighten-4" style="position: absolute; bottom: 0; width: 100%">
       <v-layout
        justify-center
        wrap
      >
        <v-btn flat small @click="sendSuggestion"><v-icon small>mail_outline</v-icon>Предложения</v-btn>
        <v-btn flat small @click="sendError"><v-icon small>error_outline</v-icon>Замечания</v-btn>
      <v-flex
        text-xs-center
        xs12
        class="caption"
      >
       &copy;2016-2026 OOO "БВР"
      </v-flex>
      </v-layout>
    </v-card>
      <!-- </v-footer> -->
    </v-navigation-drawer>
    <v-toolbar color="primary" fixed app dark clipped-left>
      <!-- <v-toolbar-side-icon @click.stop="drawer = !drawer" ></v-toolbar-side-icon> -->
      <v-btn icon @click.stop="drawer = !drawer"  :color="getOpenSettings.env !== 'test' ? 'primary' : 'secondary'">
      <img src="/static/img/icons/logo.png" height="32px">
      </v-btn>
      <v-toolbar-title  v-show="!getIsMobile" v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title v-show="!getIsMobile">{{profile.clientNameShort}}</v-toolbar-title>
      <v-btn v-show="!isLogged()" flat dark @click="$router.push('/login')">
        Вход
      </v-btn>
        <v-menu offset-y>
              <v-btn v-show="isLogged()" slot="activator" flat dark>
                <v-badge v-show="getActionBadgeValue > 0" overlap :color="getActionBadgeColor">
                  <span slot="badge">{{getActionBadgeValue}}</span>
                  {{profile.nameShort}}
                </v-badge>
                <span v-show="!getActionBadgeValue">{{profile.nameShort}}</span>
                <v-icon>arrow_drop_down</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile v-for="(item, i) in profileMenu" :key="i" @click="$router.push(item.route)">
                  <v-badge v-show="item.badge && item.badge > 0" right :color="item.badgeColor">
                    <span slot="badge">{{item.badge}}</span>
                    <v-list-tile-title v-text="item.title"></v-list-tile-title>
                  </v-badge>
                  <v-list-tile-title v-show="!item.badge || item.badge === 0" v-text="item.title"></v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="logout">
                  <v-list-tile-title>Выход</v-list-tile-title>
                </v-list-tile>
              </v-list>
        </v-menu>
    </v-toolbar>
    <v-content>
    <v-snackbar
      :value="alertShow" v-on:input="onCloseAlert"
      top
      auto-height
      :color="getAlertColor"
      multi-line
      :timeout="getAlertTimeout"
    >
    <v-layout column  style="margin: -24px">
     <v-panel-title @click="showDetails = !showDetails" :value="showDetails" :caption="showDetails ? 'Кратко' : 'Подробно'" :expandable="expandDetails" :primary="false">
        <v-layout row>
        <v-flex>
          {{status.message}}
        </v-flex>
        <v-btn icon @click="onCloseAlert">
          <v-icon>close</v-icon>
        </v-btn>
        </v-layout>
        <!-- <v-flex pt-4 v-show="showDetails" style="word-break: break-word">{{status.details}}</v-flex> -->
          <v-card-text v-show="showDetails" style="display: block; overflow: auto; overflow-wrap: break-word; color:rgba(0,0,0,0.87); background-color: white;">
            <div v-html="status.details">
            </div>
          </v-card-text>
      </v-panel-title>
    </v-layout>
    </v-snackbar>
    <router-view></router-view>
      <v-modal-factory ref="modal" v-show="isLogged()"></v-modal-factory>
    </v-content>
  </v-container>
</template>

<script>
  // import Vue from 'vue'
  import { mapGetters } from 'vuex'
  import vModalFactory from '../components/common/ModalFactory.vue'
  import dialogs from '../components/common/dialogs'
  import vPanelTitle from '../components/info/PanelTitle'

  export default {
    name: 'full',
    components: {vModalFactory, vPanelTitle},
    data () {
      return {
        title: 'АТЛАНТ-СМАРТ',
        showDetails: false,
        drawer: this.$vuetify.breakpoint.lgAndUp
      }
    },
    created () {
      this.$store.dispatch('fetchOpenSettings')
      this.$store.commit('setBreakpoint', this.$vuetify.breakpoint)
    },
    mounted () {
      dialogs.setModalFactory(this.$refs.modal)
    },
    watch: {
      '$vuetify.breakpoint' (newVal) {
        this.$store.commit('setBreakpoint', newVal)
      }
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile',
        status: 'getStatus',
        profile: 'getProfile',
        getIsAuthorized: 'getIsAuthorized',
        counters: 'getDashboardCounters',
        getOpenSettings: 'getOpenSettings'
      }),
      alertShow () {
        return this.status.show
      },
      expandDetails () {
        console.log('expandDetails', this.status)
        return this.status.details != null
      },
      getAlertColor () {
        return this.status.type ? this.status.type : 'info'
      },
      getAlertTimeout () {
        switch (this.status.type) {
          case 'info': return 6000
          case 'error': return 0
          case 'success': return 6000
          case 'warning': return 0
        }
      },
      getActionBadgeColor () {
        return this.counters.newActions && this.counters.newActions.error > 0 ? 'warning' : 'info'
      },
      getActionBadgeValue () {
        return this.counters.newActions && (this.counters.newActions.error || this.counters.newActions.process)
      },
      profileMenu () {
        var menu = [{
          icon: '',
          title: this.profile.nameShort,
          route: '/profile'
        }]
        if (this.profile && this.profile.haveClient) {
          menu.push({
            icon: '',
            title: this.profile.clientNameShort,
            route: '/client_profile'
          })
        }
        if (this.profile && this.profile.haveClient) {
          menu.push({
            icon: '',
            title: 'Журнал',
            route: '/profile_log',
            badge: this.getActionBadgeValue,
            badgeColor: this.getActionBadgeColor
          })
        }
        return menu
      }
    },
    methods: {
      isLogged () {
        return this.getIsAuthorized(true)
      },
      onCloseAlert () {
        this.showDetails = false
        this.$store.commit('closeAlert')
      },
      logout () {
        this.$store.dispatch('logout')
      },
      items () {
        return this.isLogged() ? [
          {
            icon: 'home',
            title: 'Главная',
            route: '/home'
          },
          {
            icon: 'storage',
            title: 'Депозитарий',
            route: '/doc_list/root'
          },
          {
            icon: 'people_outline',
            title: 'Физические лица',
            route: '/people'
          },
          {
            icon: 'contacts',
            title: 'Мои контрагенты',
            route: '/favoritecompanies'
          },
          {
            icon: 'alarm',
            title: 'Мониторинг',
            route: '/monitoring_page'
          },
          {
            icon: 'chat',
            title: 'Сообщения',
            route: '/chats/root',
            badge: this.counters.notReviewedChats
          },
          {
            icon: 'search',
            title: 'Компании, ИП',
            route: '/clients'
          },
          {
            icon: 'school',
            title: 'Делопроизводство',
            route: '/assist'
          },
          {
            icon: 'file_download',
            title: 'Импорт',
            route: '/payment'
          }
        ] : [
          {
            icon: 'home',
            title: 'Главная',
            route: '/home'
          },
          {
            icon: 'search',
            title: 'Компании, ИП',
            route: '/clients'
          }
        ]
      },
      sendError () {
        var email = this.getOpenSettings.supportMail
        var subject = 'Сообщение об ошибке в Системе "АТЛАНТ-СМАРТ"'
        var emailBody = ''.concat(
        'Господа,',
        '\n\t',
        `cообщаю Вам об ошибке обнаруженной мной в версии ${this.getOpenSettings.version},`,
        '\n\tна странице',
        `\n\t\t${document.location}`,
        '\n',
        '\n Описание ошибки ',
        '\n',
        '\n',
        '<ВВЕДИТЕ ИНФОРМАЦИЮ ОБ ОШИБКЕ>',
        '\n',
        '\n С уважением, ',
        this.isLogged() ? this.profile.nameShort : '<ВВЕДИТЕ ВАШЕ ИМЯ>',
        '\n',
        this.isLogged() ? `${this.profile.clientNameShort} \n ИНН ${this.profile.clientInn}` : ''
        )
        this.$store.dispatch('mailTo', {email: email, subject: subject, emailBody: emailBody})
      },
      sendSuggestion () {
        var email = this.getOpenSettings.supportMail
        var subject = 'Предложение по развитию Системы "АТЛАНТ-СМАРТ"'
        var emailBody = ''.concat(
        'Господа,',
        '\n\t',
        `хочу поделиться идеями по улучшению Системы "АТЛАНТ-СМАРТ" версии ${this.getOpenSettings.version}`,
        '\n',
        '\n',
        '<ВВЕДИТЕ ИНФОРМАЦИЮ О ПРЕДЛОЖЕНИИ>',
        '\n',
        '\n',
        'С уважением, ',
        this.isLogged() ? this.profile.nameShort : '<ВВЕДИТЕ ВАШЕ ИМЯ>',
        '\n',
        this.isLogged() ? `${this.profile.clientNameShort} \n ИНН ${this.profile.clientInn}` : ''
        )
        this.$store.dispatch('mailTo', {email: email, subject: subject, emailBody: emailBody})
      }
    }
  }
</script>
<style>
  .container.fluid {
    padding: 0;
  }
  /*VN instead fill-height for container, because fill-height center items also*/
  .v-content {
    height: 100%;
  }
  .v-list--three-line .v-list__tile__sub-title {
  height: 42px;
  }
  /*.v-snack--multi-line .v-snack__content {*/
    /*padding: 8px;*/
  /*}*/
</style>




// WEBPACK FOOTER //
// Full.vue?32c2e570